
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staycation/booking-page",
      function () {
        return require("private-next-pages/staycation/booking-page/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staycation/booking-page"])
      });
    }
  